import React from 'react';
import './happyHalloween.css';

/**
 * Login greeting adapted from Rachel's pure-CSS pen:
 * https://codepen.io/rachel_web/pen/MjxzOb
 * Corner webs are inline SVG instead of the pen's external images.
 */
function Spider({ index }) {
  return (
    <div className={`bqa-hh-spider bqa-hh-spider-${index}`}>
      <div className="bqa-hh-eye bqa-hh-eye-left" />
      <div className="bqa-hh-eye bqa-hh-eye-right" />
      <span className="bqa-hh-leg bqa-hh-leg-left" />
      <span className="bqa-hh-leg bqa-hh-leg-left" />
      <span className="bqa-hh-leg bqa-hh-leg-left" />
      <span className="bqa-hh-leg bqa-hh-leg-left" />
      <span className="bqa-hh-leg bqa-hh-leg-right" />
      <span className="bqa-hh-leg bqa-hh-leg-right" />
      <span className="bqa-hh-leg bqa-hh-leg-right" />
      <span className="bqa-hh-leg bqa-hh-leg-right" />
    </div>
  );
}

function CornerWeb({ className }) {
  return (
    <svg className={className} viewBox="0 0 160 160" aria-hidden="true">
      <g fill="none" stroke="currentColor" strokeWidth="1.2">
        <path d="M4 4 L156 22" />
        <path d="M4 4 L156 72" />
        <path d="M4 4 L150 156" />
        <path d="M4 4 L72 156" />
        <path d="M4 4 L18 156" />
        <path d="M28 10 Q52 40 12 48" />
        <path d="M56 16 Q92 68 18 90" />
        <path d="M86 24 Q128 104 28 132" />
        <path d="M114 32 Q148 132 40 152" />
      </g>
    </svg>
  );
}

export default function HappyHalloween() {
  return (
    <div className="bqa-hh" aria-hidden="true">
      <CornerWeb className="bqa-hh-web bqa-hh-web-left" />
      <CornerWeb className="bqa-hh-web bqa-hh-web-right" />
      {[0, 1, 2, 3, 4, 5].map((index) => (
        <Spider key={index} index={index} />
      ))}
      <p className="bqa-hh-title">Happy Halloween!</p>
    </div>
  );
}
